<!-- Input Container -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="relative w-full group">
  @if (label()) {
    <label [class]="labelClasses">{{ label() }}</label>
  }

  <!-- Input with Search Icon and Keyboard Navigation -->
  <input
    #inputElement
    type="text"
    [value]="_displayValue"
    [placeholder]="placeholder()"
    [disabled]="_disabledByForm()"
    [class]="inputClasses()"
    (input)="onInput($event)"
    (blur)="onTouched()"
    [appAutocompleteKeyboardNavigation]="isOverlayOpen()"
    (navigationAction)="onNavigationAction($event)"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="isOverlayOpen()"
    [attr.aria-controls]="'autocomplete-listbox'"
    [attr.aria-activedescendant]="getActiveDescendant()" />

  <!-- Search Icon (FontAwesome) -->
  <fa-icon
    [icon]="faSearch"
    class="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-700 pointer-events-none">
  </fa-icon>
</div>

<!-- Overlay Content (ng-template attached via CDK) -->
<ng-template #overlayContent>
  <div
    class="bg-white border border-foreground/20 rounded-lg shadow-sm max-h-60 overflow-y-auto">
    <!-- Loading State -->
    @if (loading()) {
      <div class="p-4 text-sm text-neutral-700">Loading...</div>
    }

    <!-- Options List -->
    @if (!loading() && options().length > 0) {
      <ul role="listbox" id="autocomplete-listbox">
        @for (option of options(); track option.value; let i = $index) {
          <li
            [id]="'option-' + i"
            [class]="
              'px-4 py-2 cursor-pointer' +
              (focusedOptionIndex() === i
                ? ' bg-foreground-10'
                : ' hover:bg-foreground-5')
            "
            (click)="selectOption(option)"
            (mouseenter)="onOptionMouseEnter(i)"
            tabindex="0"
            role="option"
            [attr.aria-selected]="false">
            {{ option.listLabel ?? option.label }}
          </li>
        }
      </ul>
    }

    <!-- No Results -->
    @if (!loading() && options().length === 0) {
      <div class="p-4 text-sm text-neutral-700">No results found</div>
    }

    <!-- Divider + Custom Value Row (Always show when typing) -->
    @if (showCustomValueRow()) {
      <div class="border-t border-foreground/20"></div>
      <div
        [id]="'custom-value-option'"
        [class]="
          'px-4 py-2 cursor-pointer flex items-center gap-2 text-primary-80' +
          (isFocusedOnCustomRow()
            ? ' bg-foreground-10'
            : ' hover:bg-foreground-5')
        "
        (click)="useCustomValue()"
        (mouseenter)="onCustomValueMouseEnter()"
        tabindex="0"
        role="option"
        [attr.aria-selected]="false">
        <fa-icon [icon]="faPlus" class="text-sm"></fa-icon>
        <span>Use "{{ _displayValue }}"</span>
      </div>
    }
  </div>
</ng-template>
